import { Box, CalendarTodayIcon, Flex, ReadonlyField, Text } from '@shared/components';
import { formatDate } from '@shared/utils';

export interface ProctoringEkycInformationVerificationProps {
  slotProps?: {
    name?: {
      title: string;
      firstName: string;
      middleName?: string | null;
      lastName: string;
    };
    document?: {
      idNumber: string;
    };
    dateOfBirth?: Date;
  };
}

export default function ProctoringEkycInformationVerification(
  props: Readonly<ProctoringEkycInformationVerificationProps>,
) {
  const { slotProps } = props;
  return (
    <Flex sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(6), width: '100%' })}>
      <Text
        variant='h4'
        sx={(theme) => ({
          borderLeft: `4px solid ${theme.palette.primary.main}`,
          pl: theme.spacing(4),
        })}
      >
        Personal Information
      </Text>
      <Flex sx={(theme) => ({ gap: theme.spacing(6) })}>
        <Text
          variant='body1Semibold'
          sx={{
            maxWidth: '240px',
            width: '100%',
          }}
        >
          ข้อมูลส่วนตัว
        </Text>
        <Flex sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(6), width: '100%' })}>
          <Flex sx={(theme) => ({ gap: theme.spacing(4) })}>
            <ReadonlyField content='บัตรประชาชน' label='ประเภทเอกสาร' />
            <ReadonlyField
              content={slotProps?.document?.idNumber ?? ''}
              label='เลขที่บัตรประชาชน'
            />
          </Flex>
          <Flex sx={(theme) => ({ gap: theme.spacing(4) })}>
            <Box sx={{ maxWidth: '200px', width: '100%' }}>
              <ReadonlyField content={slotProps?.name?.title ?? ''} label='คำนำหน้า' />
            </Box>
            <ReadonlyField content={slotProps?.name?.firstName ?? ''} label='ชื่อ' />
            <ReadonlyField content={slotProps?.name?.middleName ?? ''} label='ชื่อกลาง' />
            <ReadonlyField content={slotProps?.name?.lastName ?? ''} label='นามสกุล' />
          </Flex>
          <Box sx={{ maxWidth: '200px', width: '100%' }}>
            <ReadonlyField
              content={
                <Flex sx={{ justifyContent: 'space-between' }}>
                  <Text>{formatDate(slotProps?.dateOfBirth ?? new Date())}</Text>
                  <CalendarTodayIcon sx={{ pointerEvents: 'none', fontSize: 24 }} />
                </Flex>
              }
              label='วันเดือนปีเกิด'
            />
          </Box>
        </Flex>
      </Flex>
    </Flex>
  );
}
